// Public Azure Function API — no auth token required

const API_BASE =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost" ? "http://localhost:7071/api" : "/api");

export interface PublicListing {
  id: string;
  subParcelId: string;
  municipio: string;
  municipioCode: number | null;
  cabida: number | null;
  uso: string;
  estatus: string;
  estatusCode: number | null;
  parcelId: string;
  fincaId: string;
  catastro: string;
  canon: number | null;
  canonBase: number | null;
  description: string;
  zoning: string;
  usoProgramado: string;
  acquisitionName: string;
}

export interface MunicipioOption {
  code: number;
  name: string;
  count: number;
}

export async function fetchListings(params: {
  municipio?: number;
  search?: string;
  top?: number;
}): Promise<{ count: number; value: PublicListing[] }> {
  const qs = new URLSearchParams();
  if (params.municipio) qs.set("municipio", String(params.municipio));
  if (params.search) qs.set("search", params.search);
  if (params.top) qs.set("top", String(params.top));

  const resp = await fetch(`${API_BASE}/parcels?${qs}`);
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  return resp.json();
}

export async function fetchListing(id: string): Promise<PublicListing> {
  const resp = await fetch(`${API_BASE}/parcels/detail/${encodeURIComponent(id)}`);
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  return resp.json();
}

export async function fetchMunicipios(): Promise<MunicipioOption[]> {
  const resp = await fetch(`${API_BASE}/parcels/municipios`);
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  const data = await resp.json();
  return data.value as MunicipioOption[];
}
